// Module
var code = "<div class=\"row\">\r\n    <div class=\"col-lg-10\">\r\n        <h3 class=\"mt-1\" data-bind=\"restext: 'ChangePassword'\"></h3>\r\n        <p data-bind=\"restext: 'ChangePasswordInstructions'\"></p>\r\n    </div>\r\n</div>\r\n";
// Exports
export default code;